module.exports = __webpack_public_path__ + "static/media/websiteapplication.03bec717.svg";